import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, UserRoundPen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export const ProfileNudgeBanner = () => {
  const navigate = useNavigate();
  const { token, isAuthenticated } = useAuth();
  const [completeness, setCompleteness] = useState(null);
  const [dismissed, setDismissed] = useState(sessionStorage.getItem('nudge_dismissed') === '1');

  useEffect(() => {
    if (!isAuthenticated || !token || dismissed) return;
    fetch(`${API}/api/recruiter/profile360`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => d.success && setCompleteness(d.completeness))
      .catch(() => {});
  }, [isAuthenticated, token, dismissed]);

  if (!isAuthenticated || dismissed || completeness === null || completeness >= 70) return null;

  return (
    <div data-testid="profile-nudge-banner" className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white pl-4 pr-10 sm:px-6 py-2 flex items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm relative">
      <UserRoundPen className="w-4 h-4 shrink-0 hidden sm:block" />
      <span className="min-w-0">
        Your profile is <strong>{completeness}% complete</strong><span className="hidden md:inline"> — finish it to get matched TA jobs and be discoverable by employers.</span>
      </span>
      <button
        data-testid="nudge-complete-btn"
        onClick={() => navigate('/profile')}
        className="bg-white text-blue-700 font-bold px-3 sm:px-4 py-1 rounded-full text-xs hover:bg-blue-50 shrink-0"
      >
        Complete now
      </button>
      <button
        data-testid="nudge-dismiss-btn"
        onClick={() => { sessionStorage.setItem('nudge_dismissed', '1'); setDismissed(true); }}
        className="absolute right-3 opacity-80 hover:opacity-100"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
